/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_UnlockInputs */

const en_camera_unlock = /** @type {(inputs: Camera_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock camera (stop following the robot)`)
};

const fr_camera_unlock = /** @type {(inputs: Camera_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déverrouiller la caméra (arrêter de suivre le robot)`)
};

const ms_sg2_camera_unlock = /** @type {(inputs: Camera_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka kunci kamera (berhenti mengikuti robot)`)
};

/**
* | output |
* | --- |
* | "Unlock camera (stop following the robot)" |
*
* @param {Camera_UnlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_unlock = /** @type {((inputs?: Camera_UnlockInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_UnlockInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_unlock(inputs)
	if (locale === "fr") return fr_camera_unlock(inputs)
	return ms_sg2_camera_unlock(inputs)
});